"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryOverviewV3ResponseScheme = exports.CategoryOverviewHeaderScheme = exports.CategoryOverviewResponseScheme = exports.CategoryOverviewItemTypeScheme = exports.CategoryOverviewContentTypeScheme = void 0;
var zod_1 = require("zod");
var widgets_1 = require("./widgets");
exports.CategoryOverviewContentTypeScheme = zod_1.z.object({
    title: zod_1.z.string(),
    iconUrl: zod_1.z.string().optional(),
    action: widgets_1.CommonResponseItemActionDto,
    logMeta: zod_1.z
        .object({
        cateType: zod_1.z.string(),
        categoryAreaDetailTitle: zod_1.z.string(),
    })
        .optional(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
});
exports.CategoryOverviewItemTypeScheme = zod_1.z.object({
    title: zod_1.z.string(),
    businesses: zod_1.z.array(exports.CategoryOverviewContentTypeScheme),
    themes: zod_1.z.array(exports.CategoryOverviewContentTypeScheme).optional(),
});
exports.CategoryOverviewResponseScheme = zod_1.z.object({
    category: zod_1.z.object({
        items: zod_1.z.array(exports.CategoryOverviewItemTypeScheme),
    }),
});
// V3 버전의 scheme
exports.CategoryOverviewHeaderScheme = zod_1.z.object({
    type: zod_1.z.string(),
    title: zod_1.z.string().nullish().optional(),
    logoUrl: zod_1.z.string().nullish().optional(),
    imageUrl: zod_1.z.string().nullish().optional(),
    action: widgets_1.CommonResponseItemActionDto,
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
});
exports.CategoryOverviewV3ResponseScheme = zod_1.z.object({
    searchBar: zod_1.z.object({
        placeholder: zod_1.z.string(),
        action: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }),
    }),
    categories: zod_1.z.array(zod_1.z.object({
        header: exports.CategoryOverviewHeaderScheme.optional(),
        isHighlight: zod_1.z.boolean().optional(),
        businesses: zod_1.z.array(exports.CategoryOverviewContentTypeScheme),
        themes: zod_1.z.array(exports.CategoryOverviewContentTypeScheme).optional(),
    })),
});
